import { view } from '@yola/ws-sdk';
import { APPEARANCE_TAB_ID } from '../constants/common';
import { decorativeOptionTypes } from '../constants/option-types';
import mappingOptionElementIdsToAttributes from './mapping-option-element-ids-to-attributes';

const getInitialState = (settings) =>
  settings.reduce((acc, setting) => {
    const { tabs } = setting;
    const appearanceTab = tabs.find((tab) => tab.id.endsWith(APPEARANCE_TAB_ID));

    if (!appearanceTab) return acc;

    appearanceTab.options.forEach((option) => {
      if (decorativeOptionTypes.includes(option.type)) {
        return;
      }

      const { elementIds } = option;
      const elementIdsToAttributes = mappingOptionElementIdsToAttributes(option);

      elementIds.forEach((id) => {
        acc[id] = acc[id] || {};

        elementIdsToAttributes[id].forEach((attribute) => {
          const hasAttr = view.verifiers.hasElementAttribute(id, attribute);
          acc[id][attribute] = hasAttr
            ? view.accessors.getElementAttribute(id, attribute) || true
            : false;
        });
      });
    });

    return acc;
  }, {});

export default getInitialState;
